import type { MiddlewareState, Placement } from "@floating-ui/vue";

/** Whether the popover opens beside its trigger (a submenu) rather than above or below it. */
export function isSidePlacement(placement: Placement): boolean {
  return placement.startsWith("left") || placement.startsWith("right");
}

/**
 * Room to keep free below the popover for its own vertical margins: on small screens it gets a top
 * margin that pushes it down past the position floating-ui computes.
 */
export function marginPadding({ elements }: Pick<MiddlewareState, "elements">): { bottom: number } {
  const { marginTop, marginBottom } = getComputedStyle(elements.floating);
  return { bottom: (parseFloat(marginTop) || 0) + (parseFloat(marginBottom) || 0) };
}
